document.addEventListener("DOMContentLoaded", function () {
  const navLinks = document.querySelectorAll(".nav-link");
  const childLinks = document.querySelectorAll(".category-link");
  const grandchildContainers = document.querySelectorAll(
    ".convx__third-level-nav"
  );

  const containers = document.querySelectorAll(
    ".convx__nav-category-highlights"
  );

  containers.forEach((container) => {
    let isDragging = false;
    let startX, scrollLeft;

    container.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener("mouseleave", () => {
      isDragging = false;
    });

    container.addEventListener("mouseup", () => {
      isDragging = false;
    });

    container.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      container.scrollLeft = scrollLeft - walk;
    });
  });

  let isFirst = true;

  // First-Level Dropdown Toggle
  navLinks.forEach((link) => {
    link.addEventListener("mouseover", function (e) {
      e.preventDefault();
      link.classList.add("open");
      const dropdown = this.nextElementSibling;

      navLinks.forEach((tab) => {
        tab.classList.remove("open");
      });
      // Close all other dropdowns
      closeAllDropdowns();
      // Toggle the current dropdown
      if (dropdown) {
        dropdown.classList.toggle("open");
        link.classList.add("open");
        toggleBodyScroll(true); // Disable scrolling
        openFirstCategory(dropdown);
      }
      if (isFirst && link.textContent === "All Products") {
           window.glideSlider.update()
       }
    });

    link.addEventListener("click", function (e) {
      if (window.matchMedia("(pointer: coarse)").matches && !e.target.closest(".mega-menu__all-products")) {
        e.preventDefault();
      }
      link.classList.add("open");
      const dropdown = this.nextElementSibling;

      navLinks.forEach((tab) => {
        tab.classList.remove("open");
      });
      // Close all other dropdowns
      closeAllDropdowns();
      // Toggle the current dropdown
      if (dropdown) {
        dropdown.classList.toggle("open");
        link.classList.add("open");
        toggleBodyScroll(true); // Disable scrolling
        openFirstCategory(dropdown);
        
      }
      if (isFirst && link.textContent === "All Products") {
           window.glideSlider.update()
       }
    });
  });

  // Second-to-Third Level Interaction
  childLinks.forEach((link) => {
    link.addEventListener("mouseover", function (e) {
      e.preventDefault();

      // Exclude links with data-parent-link="All Products"
      if (link.getAttribute("data-parent-link") === "All Products") {
        return;
      }

      const targetContainer = this.getAttribute("data-nav-child-link");
      const currentDropdown = this.closest(".mega-dropdown");

      childLinks.forEach((tab) => {
        tab.classList.remove("active");
      });
      link.classList.add("active");

      // Hide all third-level containers within the current first-level dropdown
      const grandchildContainersInDropdown = currentDropdown.querySelectorAll(
        ".convx__third-level-nav"
      );
      grandchildContainersInDropdown.forEach((container) => {
        container.classList.remove("active");
      });

      // Show the matching third-level container scoped to the current first-level context
      const activeContainer = currentDropdown.querySelector(
        `.convx__third-level-nav[data-grandchild-container="${targetContainer}"]`
      );
      if (activeContainer) {
        activeContainer.classList.add("active");
      }
    });

    link.addEventListener("click", function (e) {
      if (window.matchMedia("(pointer: coarse)").matches && !e.target.closest(".mega-menu__all-products")) {
        e.preventDefault();
      }

      // Exclude links with data-parent-link="All Products"
      if (link.getAttribute("data-parent-link") === "All Products") {
        return;
      }

      const targetContainer = this.getAttribute("data-nav-child-link");
      const currentDropdown = this.closest(".mega-dropdown");

      childLinks.forEach((tab) => {
        tab.classList.remove("active");
      });
      link.classList.add("active");

      // Hide all third-level containers within the current first-level dropdown
      const grandchildContainersInDropdown = currentDropdown.querySelectorAll(
        ".convx__third-level-nav"
      );
      grandchildContainersInDropdown.forEach((container) => {
        container.classList.remove("active");
      });

      // Show the matching third-level container scoped to the current first-level context
      const activeContainer = currentDropdown.querySelector(
        `.convx__third-level-nav[data-grandchild-container="${targetContainer}"]`
      );
      if (activeContainer) {
        activeContainer.classList.add("active");
      }
    });
  });

    function openFirstCategory(dropdown) {
    if (dropdown && !dropdown.classList.contains('mega-menu__all-products')) {
      const rightMenus = dropdown.querySelectorAll(
        ".convx__mega-menu-right-section .convx__third-level-nav"
      );
      const leftMenus = dropdown.querySelectorAll(
        ".convx__mega-menu-left-section .category-link"
      );

      leftMenus.forEach((leftMenu) => {
        leftMenu.classList.remove("active");
      });
      

      rightMenus.forEach((rightMenu) => {
        rightMenu.classList.remove("active");
      });

      if (!rightMenus[0].classList.contains('convx__keyboard-container-landing')) {
        leftMenus[0].classList.add("active");
      }
      rightMenus[0].classList.add("active");
    }
  }

  // Function to close all first-level dropdowns
  function closeAllDropdowns() {
    document.querySelectorAll(".mega-dropdown").forEach((dropdown) => {
      dropdown.classList.remove("open");
    });
    navLinks.forEach((tab) => {
      tab.classList.remove("open");
    });
    toggleBodyScroll(false); // Enable scrolling
  }

  // Function to toggle scroll on body
  function toggleBodyScroll(disable) {
    if (disable) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }

  // Close dropdowns when clicking outside
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".top-nav")) {
      closeAllDropdowns();
    }
  });

  document.addEventListener("mouseover", (e) => {
    if (!e.target.closest(".top-nav")) {
      closeAllDropdowns();
    }
  });

  document
    .querySelectorAll(".convx__mega-menu-nav-close")
    .forEach((closeBtn) => {
      closeBtn.addEventListener("click", (e) => {
        closeAllDropdowns();
      });
    });
});

(() => {
  "use strict";

  function main() {
    document.addEventListener('DOMContentLoaded', function () {
      window.glideSlider = new Glide('.convx__mega-menu-new-arrivals .glide', {
        type: 'carousel',
        perView: 4.5,
        gap: 10,
        breakpoints: {
          768: { perView: 4 },
          480: { perView: 3 }
        }
      }).mount();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }
})();
